
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Shop } from "../types";
import { supabase } from "@/lib/supabase/client";

export const useShopDeletion = (shop: Shop) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [confirmationText, setConfirmationText] = useState("");
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const navigate = useNavigate();

  const expectedConfirmationText = `SUPPRIMER-${shop.name}`;

  const openConfirmDialog = () => {
    setIsConfirmDialogOpen(true);
    setConfirmationText("");
  };

  const closeConfirmDialog = () => {
    setIsConfirmDialogOpen(false);
    setConfirmationText("");
  };

  const handleDeleteShop = async () => {
    if (confirmationText !== expectedConfirmationText) {
      toast.error("Le texte de confirmation est incorrect");
      return;
    }

    try {
      setIsDeleting(true);
      
      // Suppression de la boutique dans la base de données
      const { error } = await supabase
        .from("shops")
        .delete()
        .eq("id", shop.id);

      if (error) {
        throw new Error(error.message);
      }

      toast.success("Boutique supprimée avec succès", {
        description: `La boutique "${shop.name}" a été supprimée.`
      });
      
      // Rediriger vers le dashboard
      navigate("/dashboard");
    } catch (error: any) {
      console.error("Erreur lors de la suppression de la boutique:", error);
      toast.error("Erreur lors de la suppression", {
        description: error.message || "Une erreur est survenue lors de la suppression de la boutique"
      });
    } finally {
      setIsDeleting(false);
      closeConfirmDialog();
    }
  };

  return {
    isDeleting,
    confirmationText,
    setConfirmationText,
    isConfirmDialogOpen,
    openConfirmDialog,
    closeConfirmDialog,
    handleDeleteShop,
    expectedConfirmationText
  };
};
